// eslint-disable-next-line import/no-extraneous-dependencies
import { utcToZonedTime, format } from 'date-fns-tz';

export default class Schedule {
  constructor(entries) {
    this.entries = entries;
  }

  entriesTable(entries, timeZone) {
    const $title = $('<h3></h3>')
      .text(format(entries[0].time, 'eeee, LLLL d', { timeZone }));
    const $table = $('<table></table>').addClass('table')
      .append(
        $('<tbody></tbody>')
          .append(
            entries
              .sort((a, b) => (a.time < b.time ? -1 : 1))
              .map(entry => $('<tr>')
                .addClass($(entry.body).hasClass('entry-break') ? 'break' : null)
                .append($('<td class="col-time"></td>')
                  .append($('<div class="time"></div>')
                    .html(format(entry.time, 'h:mmaaa', { timeZone })))
                  .append($('<div class="timezone"></div>')
                    .html(format(entry.time, 'O', { timeZone }))))
                .append($('<td></td>').html(entry.body)))
          )
      );

    return [$title, $table];
  }

  render(timeZone) {
    const groups = [];
    let currGroup = [];
    this.entries.forEach((entry) => {
      const zonedEntry = Object.assign({}, entry,
        { time: utcToZonedTime(entry.time, timeZone) });
      if (currGroup.length !== 0 && (
        currGroup[0].time.getFullYear() !== zonedEntry.time.getFullYear()
        || currGroup[0].time.getMonth() !== zonedEntry.time.getMonth()
        || currGroup[0].time.getDate() !== zonedEntry.time.getDate()
      )) {
        groups.push(currGroup);
        currGroup = [];
      }
      currGroup.push(zonedEntry);
    });
    if (currGroup.length > 0) {
      groups.push(currGroup);
    }
    return $('<div></div>').addClass('schedule-content')
      .append(...groups.map(group => this.entriesTable(group, timeZone)));
  }
}
